import defineComponent from 'flight';
import userPreferences from 'static/script/app/data/user-preferences';

function SideMenuUI() {
    this.defaultAttrs({
        sideMenuClose: '[data-side-menu-close]',
        subMenuToggler: '[data-side-menu-sub-toggler]',
        subMenu: '[data-side-menu-sub]',
        myTraderaLink: '[data-my-tradera-link]'
    });

    this._toggleSubMenu = function (evt) {
        let parent = $(evt.target).parent();
        parent.toggleClass('active');

        if (parent.hasClass('active')) {
            this._forceReflowIfAndroid();
        }
    };

    this._sideMenuCloseClicked = function () {
        this.trigger(document, 'ui:side-menu:on-side-menu-close-click');
        this.trigger(document, 'analytics:track-event', {
            category: 'Header',
            action: 'Navigation',
            label: 'Side menu - close'
        });
    };

    this._resetMenu = function () {
        let el = this.$node.find('.active');
        if (!!el) {
            this.$node.find('.active').removeClass('active');
        }
    };

    this._updateMyTraderaLink = function () {
        let lastOpenTab = userPreferences.get('MyTraderaLastOpenTab');
        if (lastOpenTab && lastOpenTab.indexOf('/my/') === 0) {
            this.select('myTraderaLink').attr('href', lastOpenTab);
        }
    };

    this.after('initialize', function () {
        this.on(document, 'ui:body-container:after-side-menu-close', this._resetMenu);
        this.on(document, 'data:navigation:after-page-load', this._updateMyTraderaLink);

        this.on('click', {
            subMenuToggler: this._toggleSubMenu,
            sideMenuClose: this._sideMenuCloseClicked
        });
    });

    this._forceReflowIfAndroid = function () { // samsung galaxy tab and s2 need this to render properly, otherwise its not possible to scroll down any further than that original page's height
        if (window.Feature._getUserAgent().indexOf('Android') >= 0) {
            let forceReflow = $('<div />');
            forceReflow.addClass('force-reflow').appendTo('body');

            setTimeout(function () {
                forceReflow.remove();
            }, 200);
        }
    };
}

export default defineComponent.component(SideMenuUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/side-menu-ui.js